/* 
// Returns the ISO week of the date.
Date.prototype.getWeek = function () {
  let date = new Date(this.getTime());
  date.setHours(0, 0, 0, 0);
  // Thursday in current week decides the year.
  date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
  // January 4 is always in week 1.
  let week1 = new Date(date.getFullYear(), 0, 4);
  // Adjust to Thursday in week 1 and count number of weeks from date to week1.
  return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7);
};

const getWeekNumber = (d) => {
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  return weekNo;
};

const getWeeksInYear = (year) => {
  let d = new Date(year, 11, 31);
  let week = getWeekNumber(d);
  return week === 1 ? getWeekNumber(new Date(year, 11, 24)) : week;
};

const getDateRangeOfWeek = (weekNo, y) => {
  let d1, numOfdaysPastSinceLastMonday, rangeIsFrom, rangeIsTo;
  d1 = new Date("" + y + "");
  numOfdaysPastSinceLastMonday = d1.getDay() - 1;
  d1.setDate(d1.getDate() - numOfdaysPastSinceLastMonday);
  d1.setDate(d1.getDate() + 7 * (weekNo - d1.getWeek()));
  rangeIsFrom = d1.getDate() + "-" + monthNameShort[d1.getMonth()];
  d1.setDate(d1.getDate() + 6);
  rangeIsTo = d1.getDate() + "-" + monthNameShort[d1.getMonth()];

  return "Week " + weekNo + " (" + rangeIsFrom + " to " + rangeIsTo + ")";
};

const Daily = ({ yearTofetch, updateYearToFetch, weekToFetch, updateWeekToFetch }) => {
  return (
    <>
      <div className='dailyfilter32'>
        <div className='employeeTile22'>
          <div id='inputreset46' className='inputCustdet  '>
            <select onChange={(e) => updateYearToFetch(e.target.value)} value={yearTofetch}>
              <option value='' disabled selected hidden>
                {yearTofetch}
              </option>
              {new Array(10).fill(0).map((_, i) => (
                <option value={new Date().getFullYear() - i} key={i}>
                  {new Date().getFullYear() - i}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className='employeeTile22'>
          <div id='inputreset46' className='inputCustdet  '>
            <select onChange={(e) => updateWeekToFetch(e.target.value)} value={weekToFetch}>
              <option value='' disabled selected hidden>
                Select week number
              </option>
              {new Array(getWeeksInYear(yearTofetch)).fill(0).map((_, i) => (
                <option
                  disabled={getWeekNumber(new Date()) <= i && yearTofetch.toString() === new Date().getFullYear().toString() ? true : false}
                  value={getDateRangeOfWeek(i + 1, yearTofetch)}
                  key={i}
                >
                  {getDateRangeOfWeek(i + 1, yearTofetch)}{" "}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </>
  );
};

export default Daily;
 */

import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { getCustomDashboardUrl, getDashboardUrl } from "../../api/endpoints";
import { refreshUserToken } from "../../tools/refreshToken";
import { useNavigate } from "react-router-dom";
import "./dashboardFilter.css";

/*
  DashboardFilter
  ───────────────
  Props:
    dashboardTimeline           — string  current active period key
    updateDateDashboardToRender — fn(string)
    setDashboardData            — fn
    setRawData                  — fn
    setIsLoading                — fn
    setDashboardDataCopy        — fn

  Week labels match your original DailyFilter format exactly:
    "Week 3 (20-Jan to 26-Jan)"
  This is the value sent to the backend via getDashboardUrl.
*/

/* ── Exact ISO week helpers from your original DailyFilter ── */
export const monthNameShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// Prototype extension kept as a local fn to avoid global mutation
function getWeek(date) {
  let d = new Date(date.getTime());
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + 3 - ((d.getDay() + 6) % 7));
  const week1 = new Date(d.getFullYear(), 0, 4);
  return 1 + Math.round(((d.getTime() - week1.getTime()) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7);
}

function getWeekNumber(d) {
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
}

function getWeeksInYear(year) {
  const d = new Date(year, 11, 31);
  const week = getWeekNumber(d);
  return week === 1 ? getWeekNumber(new Date(year, 11, 24)) : week;
}

function getDateRangeOfWeek(weekNo, y) {
  let d1 = new Date("" + y + "");
  const numOfdaysPastSinceLastMonday = d1.getDay() - 1;
  d1.setDate(d1.getDate() - numOfdaysPastSinceLastMonday);
  d1.setDate(d1.getDate() + 7 * (weekNo - getWeek(d1)));
  const rangeIsFrom = d1.getDate() + "-" + monthNameShort[d1.getMonth()];
  d1.setDate(d1.getDate() + 6);
  const rangeIsTo = d1.getDate() + "-" + monthNameShort[d1.getMonth()];
  return "Week " + weekNo + " (" + rangeIsFrom + " to " + rangeIsTo + ")";
}

/* ── Month names (full) for monthly mode ── */
const MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

/* ══════════════════════════════════════════════════════
   Component
══════════════════════════════════════════════════════ */
export default function DashboardFilter({
  dashboardTimeline,
  updateDateDashboardToRender,
  setDashboardData,
  setRawData,
  setIsLoading,
  setDashboardDataCopy,
  setTransactionsInScope,
}) {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const currentWeek = getWeekNumber(new Date());

  const [overlayOpen, setOverlayOpen] = useState(false);
  const [mode, setMode] = useState("weekly");
  const [year, setYear] = useState(currentYear);
  /* Track the numeric week number separately so we can send it to the backend */
  const [selectedWeekNo, setSelectedWeekNo] = useState(currentWeek);
  const [selectedWeek, setSelectedWeek] = useState(getDateRangeOfWeek(currentWeek, currentYear));
  const [selectedMonth, setSelectedMonth] = useState(MONTH_NAMES[new Date().getMonth()]);

  /* Reset selectedWeek when year changes */
  useEffect(() => {
    setSelectedWeek(getDateRangeOfWeek(1, year));
    setSelectedWeekNo(1);
  }, [year]);

  /* Escape key */
  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape") setOverlayOpen(false);
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, []);

  const handlePeriodClick = (period) => {
    if (period === "custom") {
      setOverlayOpen(true);
      return;
    }
    updateDateDashboardToRender(period);
  };

  const handleApply = async () => {
    setOverlayOpen(false);

    /* ── Display label for topbar subtitle ── */
    const displayKey =
      mode === "weekly" ? selectedWeek /* e.g. "Week 3 (20-Jan to 26-Jan)" */ : `${selectedMonth} ${year}`; /* e.g. "January 2026"              */
    updateDateDashboardToRender(displayKey);

    /*
      Backend: POST /getCustomDashboard/:whichDashboard
        :whichDashboard = "daily"   (weekly range)
                        | "monthly"
        body (weekly):  { year, weekNo }
        body (monthly): { year, month }   — month is full name e.g. "January"
    */
    const whichDashboard = mode === "weekly" ? "daily" : "monthly";

    const body =
      mode === "weekly"
        ? { year, weekNo: selectedWeekNo, month: selectedMonth } /* weekNo is the ISO week number */
        : { year, weekNo: selectedWeekNo, month: selectedMonth }; /* month is the full month name  */
    const baseUrl = getCustomDashboardUrl + whichDashboard;
    const url = `${baseUrl}getCustomDashboard/${whichDashboard}/`;
    setIsLoading(true);
    try {
      console.log(`Requesting ${whichDashboard} dashboard with body:`, body, url, baseUrl);

      const res = await fetch(baseUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify(body),
      });
      if (res.ok) {
        const { rawData, reducedData, transactionInPeriod } = await res.json();
        setRawData(rawData);
        setDashboardData(reducedData);
        setDashboardDataCopy(reducedData);
        setTransactionsInScope(transactionInPeriod);
        console.log(`Received custom dashboard data:`, { rawData, reducedData, transactionInPeriod });
      } else if (res.status === 400) {
        refreshUserToken(`${getDashboardUrl}getCustomDashboard/${whichDashboard}/`, handleApply, navigate);
      } else {
        console.error("Custom dashboard not found", await res.json());
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const totalWeeks = getWeeksInYear(year);
  const isCurrentYear = year.toString() === currentYear.toString();
  const isCustomActive = dashboardTimeline !== "today" && dashboardTimeline !== "yesterday";

  /* Build year options — last 10 years matching original */
  const yearOptions = Array.from({ length: 10 }, (_, i) => currentYear - i);

  return (
    <>
      {/* ── Period buttons ── */}
      <div className='df-filter'>
        {["today", "yesterday", "custom"].map((p) => (
          <button
            key={p}
            className={`df-btn${(p !== "custom" && dashboardTimeline === p) || (p === "custom" && isCustomActive) ? " active" : ""}`}
            onClick={() => handlePeriodClick(p)}
          >
            {p === "custom" && (
              <svg width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' aria-hidden='true'>
                <rect x='3' y='4' width='18' height='18' rx='2' />
                <line x1='16' y1='2' x2='16' y2='6' />
                <line x1='8' y1='2' x2='8' y2='6' />
                <line x1='3' y1='10' x2='21' y2='10' />
              </svg>
            )}
            {p.charAt(0).toUpperCase() + p.slice(1)}
          </button>
        ))}
      </div>

      {/* ── Custom interval overlay ── */}
      {overlayOpen &&
        createPortal(
          <div className='df-overlay' onClick={(e) => e.target === e.currentTarget && setOverlayOpen(false)}>
            <div className='df-modal'>
              {/* Header */}
              <div className='df-modal-head'>
                <h4>Choose interval</h4>
                <button className='df-xbtn' onClick={() => setOverlayOpen(false)} aria-label='Close'>
                  <svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round'>
                    <line x1='18' y1='6' x2='6' y2='18' />
                    <line x1='6' y1='6' x2='18' y2='18' />
                  </svg>
                </button>
              </div>

              {/* Body */}
              <div className='df-modal-body'>
                {/* Weekly / Monthly toggle */}
                <div className='df-toggle'>
                  <button className={`df-tbtn${mode === "weekly" ? " active" : ""}`} onClick={() => setMode("weekly")}>
                    Weekly
                  </button>
                  <button className={`df-tbtn${mode === "monthly" ? " active" : ""}`} onClick={() => setMode("monthly")}>
                    Monthly
                  </button>
                </div>

                {/* Year — same range as original (last 10 years) */}
                <div className='df-field'>
                  <label>Year</label>
                  <div className='df-sel-wrap'>
                    <select value={year} onChange={(e) => setYear(parseInt(e.target.value))}>
                      {yearOptions.map((y) => (
                        <option key={y} value={y}>
                          {y}
                        </option>
                      ))}
                    </select>
                    <ChevronIcon />
                  </div>
                </div>

                {/* Week — uses exact getDateRangeOfWeek format, disables future weeks */}
                {mode === "weekly" && (
                  <div className='df-field'>
                    <label>Week</label>
                    <div className='df-sel-wrap'>
                      <select
                        value={selectedWeek}
                        onChange={(e) => {
                          setSelectedWeek(e.target.value);
                          setSelectedWeekNo(parseInt(e.target.options[e.target.selectedIndex].dataset.weekno));
                        }}
                      >
                        <option value='' disabled hidden>
                          Select week number
                        </option>
                        {Array.from({ length: totalWeeks }, (_, i) => {
                          const weekNo = i + 1;
                          const label = getDateRangeOfWeek(weekNo, year);
                          const isFuture = isCurrentYear && currentWeek <= i; /* disable future weeks in current year */
                          return (
                            <option key={weekNo} value={label} data-weekno={weekNo} disabled={isFuture}>
                              {label}
                            </option>
                          );
                        })}
                      </select>
                      <ChevronIcon />
                    </div>
                  </div>
                )}

                {/* Month */}
                {mode === "monthly" && (
                  <div className='df-field'>
                    <label>Month</label>
                    <div className='df-sel-wrap'>
                      <select value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
                        {MONTH_NAMES.map((m) => (
                          <option key={m} value={m}>
                            {m}
                          </option>
                        ))}
                      </select>
                      <ChevronIcon />
                    </div>
                  </div>
                )}
              </div>

              {/* Footer */}
              <div className='df-modal-foot'>
                <button className='df-cancel' onClick={() => setOverlayOpen(false)}>
                  Cancel
                </button>
                <button className='df-apply' onClick={handleApply}>
                  Get dashboard
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
}

const ChevronIcon = () => (
  <span className='df-chevron' aria-hidden='true'>
    <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round'>
      <polyline points='6 9 12 15 18 9' />
    </svg>
  </span>
);
